import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { AppErrorBoundary } from '@ui/components/AppErrorBoundary';
import { config } from './config';

// Transitional shim: config is baked at build time (see config.ts); existing
// read sites still access window.__ENV__. New code should import { config }.
window.__ENV__ = config;

const posthogKey = config.POSTHOG_PUBLIC_KEY;
const posthogHost = config.POSTHOG_PUBLIC_HOST || 'https://us.i.posthog.com';

const options = {
  api_host: posthogHost,
  capture_exceptions: true,
  session_recording: {
    maskAllInputs: true,
    maskTextSelector: '*',
  },
};

const reportError = (error: Error) => {
  if (posthogKey) posthog.captureException(error);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  posthogKey ? (
    <PostHogProvider apiKey={posthogKey} options={options}>
      <AppErrorBoundary appName="admin" onError={reportError}>
        <App />
      </AppErrorBoundary>
    </PostHogProvider>
  ) : (
    <AppErrorBoundary appName="admin">
      <App />
    </AppErrorBoundary>
  )
);
